// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"b69e8680","148":"ef04a949","387":"1279cc44","396":"5811e962","602":"21a4f432","971":"77c26a6c"}[chunkId] + ".chunk.css";
};